import React from 'react';
import { Param } from '../../cliDataSchema';

type Props = {
  param: Param;
};

const UnknownParam: React.FC<Props> = ({ param }) => {
  return (
    <div style={{ background: 'red' }}>
      No component found for type '{param.type.param_type}', param: '
      {param.name}'.
    </div>
  );
};

export default UnknownParam;
